<template>
  <ScreenHeader showCommunity @selectCommunity="selectCommunity">
    <div class="chart-container">
      <div class="upperPart mb-3 part flex-between">
        <div class="partItem upperPartItem-1">
          <div class="item-title">
            <span>项目概况</span>
            <img src="./assets/img/title-bottom-line.png" alt="" class="title-bottom-line" />
          </div>
          <div class="content">
            <div v-for="(item, index) in projectOverview" :key="index" class="detailItem">
              <div class="top mb-4">
                <count-to :start-val="0" :end-val="evaluatorNum(item.value, 0)" :duration="3000" class="item-value linearTextColor-65BFF0 countNumber" />
                <span v-if="item.value >= 10000" class="item-unit linearTextColor-65BFF0">万</span>
              </div>
              <div class="item-label">{{ item.label }}</div>
            </div>
          </div>
        </div>
        <div class="partItem upperPartItem-2">
          <div class="item-title">
            <span>房屋统计</span>
            <img src="./assets/img/title-bottom-line.png" alt="" class="title-bottom-line" />
          </div>
          <div class="chart flex-between">
            <CircularPieChart :data="houseStatistics" :ringWidth="3" :gapContent="13" :ringSize="140">
              <div class="circularRing circularRing-bg">
                <div class="top mb-4">
                  <count-to :start-val="0" :end-val="evaluatorNum(houseTotal, 0)" :duration="3000" class="item-value linearTextColor-65BFF0 countNumber" />
                  <span v-if="Number(houseTotal) >= 10000" class="item-unit linearTextColor-65BFF0">万</span>
                </div>
                <div class="item-label">房屋总数(套)</div>
              </div>
            </CircularPieChart>
            <div class="detail">
              <div v-for="(item, index) in houseStatistics" :key="index" class="item flex align-center" :class="{ 'mb-38': index !== houseStatistics.length - 1 }">
                <div class="left">
                  <img :src="item.icon" alt="" class="icon" />
                  <span class="item-label linearTextColor-65BFF0">{{ item.label }}</span>
                </div>
                <div class="right">
                  <div class="line"></div>
                  <span class="amount linearTextColor-65BFF0">{{ item.rate }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="partItem upperPartItem-3">
          <div class="item-title">
            <span>工单统计</span>
            <img src="./assets/img/title-bottom-line.png" alt="" class="title-bottom-line" />
          </div>
          <div class="content">
            <div class="chart flex-between">
              <DynamicCircularRing :outerRingDiameter="138" animation>
                <div class="circularRing circularRing-bg totalDetail">
                  <div class="top mb-4">
                    <count-to :start-val="0" :end-val="evaluatorNum(workOrderTotal, 0)" :duration="3000" class="item-value linearTextColor-65BFF0 countNumber" />
                    <span v-if="Number(workOrderTotal) >= 10000" class="item-unit linearTextColor-65BFF0">万</span>
                  </div>
                  <div class="item-label">工单总数(单)</div>
                </div>
              </DynamicCircularRing>
              <div class="detail">
                <div v-for="(item, index) in workOrderStatistics" :key="index" class="item flex align-center" :class="{ 'mb-18': index !== workOrderStatistics.length - 1 }">
                  <div class="leftBox">
                    <img :src="item.icon" alt="" class="icon" />
                    <span class="item-label linearTextColor-65BFF0">{{ item.label }}</span>
                  </div>
                  <div class="right">
                    <div class="line"></div>
                    <div>
                      <span class="amount linearTextColor-65BFF0">{{ item.value }}</span>
                      <span class="item-unit linearTextColor-65BFF0">{{ item.unit }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ScrollingNoticeBar
              v-if="communityData.communityWorksheetMessages && communityData.communityWorksheetMessages.length"
              :messages="communityData.communityWorksheetMessages"
            />
          </div>
        </div>
      </div>
      <div class="centerPart mb-3 part flex-between">
        <div class="partItem centerPartItem-1">
          <div class="item-title">
            <span>人员配置</span>
            <img src="./assets/img/title-bottom-line.png" alt="" class="title-bottom-line" />
          </div>
          <div class="content flex-between">
            <div class="charts flex-between">
              <DynamicCircularRing
                v-for="(item, index) in personnelList"
                :key="index"
                :point="false"
                innerRingBackgroundColor="#032160"
                :outerRingDiameter="98"
                :innerRingDiameter="86"
                :roundColor="item.roundColor"
              >
                <div class="circularRing">
                  <div class="top mb-4">
                    <count-to :start-val="0" :end-val="evaluatorNum(item.value, 0)" :duration="3000" class="item-value linearTextColor-65BFF0 countNumber" />
                    <span v-if="item.value >= 10000" class="item-unit linearTextColor-65BFF0">万</span>
                  </div>
                  <div class="item-label">{{ item.title }}</div>
                </div>
              </DynamicCircularRing>
            </div>
            <div class="rightDetail">
              <div v-for="(item, index) in personnelData" :key="index" class="list">
                <div class="left flex align-center">
                  <span class="item-label mr-8">{{ item.personnelName }}</span>
                  <HorizontalBarChart :percentage="item.value / personnelList[0].value" :apertureColor="item.apertureColor" :color="item.color" :lineWidth="284" />
                </div>
                <div class="right linearTextColor-65BFF0">
                  <span class="value">{{ evaluatorNum(item.value) }}</span>
                  {{ evaluatorUnit(item.value, '人') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="partItem centerPartItem-2">
          <div class="item-title">
            <span>住户统计</span>
            <img src="./assets/img/title-bottom-line.png" alt="" class="title-bottom-line" />
          </div>
          <div class="center flex-between">
            <CircularPieChart :data="outData" :ringWidth="2" :ringSize="150" :gapContent="12" :gapDeg="0" gradientType="gradient">
              <CircularPieChart :data="[...householdStatistics, ...otherHouseholdStatistics]" :ringWidth="6">
                <div class="context">
                  <div class="circularRing">
                    <div class="top mb-4">
                      <count-to :start-val="0" :end-val="evaluatorNum(housesHoldTotal, 0)" :duration="3000" class="item-value linearTextColor-65BFF0 countNumber" />
                      <span v-if="Number(housesHoldTotal) >= 10000" class="item-unit linearTextColor-65BFF0">万</span>
                    </div>
                    <div class="item-label">住户总数(人)</div>
                  </div>
                  <div
                    v-for="item in 20"
                    :key="item"
                    class="strip__wrapper"
                    :style="{
                      rotate: `${(item * 360) / 20}deg`,
                    }"
                  >
                    <div class="strip" />
                  </div>
                </div>
              </CircularPieChart>
            </CircularPieChart>
            <div class="detail">
              <div v-for="(item, index) in householdStatistics" :key="index" class="item" :class="{ 'mb-27': index !== householdStatistics.length - 1 }">
                <div class="left">
                  <img :src="item.icon" alt="" class="icon" />
                  <span class="item-label linearTextColor-65BFF0">{{ item.label }}</span>
                </div>
                <div class="flex-center">
                  <div class="line"></div>
                  <span class="amount linearTextColor-65BFF0">{{ item.rate }}%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom detail flex-between">
            <div v-for="(item, index) in otherHouseholdStatistics" :key="index" class="item flex-between">
              <div class="left">
                <img :src="item.icon" alt="" class="icon" />
                <span class="item-label linearTextColor-65BFF0">{{ item.label }}</span>
              </div>
              <div class="flex-center">
                <div class="line"></div>
                <span class="amount linearTextColor-65BFF0">{{ item.rate }}%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="partItem centerPartItem-3">
          <div class="item-title">
            <span>服务统计</span>
            <img src="./assets/img/title-bottom-line.png" alt="" class="title-bottom-line" />
          </div>
          <div class="content">
            <div class="chart-service">
              <div v-for="(item, index) in serviceData" :key="index" class="list">
                <div class="left flex align-center">
                  <div class="item-label mr-8">{{ item.label }}</div>
                  <HorizontalBarChart :percentage="item.total / serviceTotal" :apertureColor="item.apertureColor" :color="item.color" :lineWidth="421" />
                </div>
                <div class="value">
                  <span class="item-value linearTextColor-65BFF0">{{ evaluatorNum(item.total, 0) }}</span>
                  <span class="item-unit linearTextColor-65BFF0">{{ evaluatorUnit(item.total, '次') }}</span>
                </div>
              </div>
              <ScrollingNoticeBar
                v-if="communityData.communityServiceMessages && communityData.communityServiceMessages.length"
                :messages="communityData.communityServiceMessages"
                class="mt-20"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="lowerPart part flex-between">
        <div class="partItem lowerPartItem-1">
          <div class="item-title">
            <span>收费情况</span>
            <img src="./assets/img/title-bottom-line.png" alt="" class="title-bottom-line" />
          </div>
          <div class="content">
            <div class="situation flex-between">
              <div v-for="(item, index) in feeSituation" :key="index" class="listItem">
                <div class="top mb-4">
                  <count-to
                    :start-val="0"
                    :end-val="evaluatorNum(item.value)"
                    :decimals="countToDecimal(item.value)"
                    :duration="3000"
                    class="item-value linearTextColor-65BFF0 countNumber"
                  />
                  <span class="item-unit linearTextColor-65BFF0">{{ evaluatorUnit(item.value, '元') }}</span>
                </div>
                <div class="item-label">{{ item.label }}</div>
              </div>
            </div>
            <div class="charts flex-between" :class="{ 'mb-27': !communityData.communityOrderMessages || !communityData.communityOrderMessages.length }">
              <DynamicCircularRing
                v-for="(item, index) in payList"
                :key="index"
                :point="false"
                innerRingBackgroundColor="#042264"
                :targetDeg="(360 / Number(totalFeeAmount).toFixed(0)) * Number(item.amount).toFixed(0)"
                :outerRingDiameter="120"
                :innerRingDiameter="108"
                animation
                :roundColor="item.roundColor"
              >
                <div class="circularRing">
                  <div class="top mb-4">
                    <count-to
                      :start-val="0"
                      :end-val="evaluatorNum(item.amount)"
                      :decimals="countToDecimal(item.amount)"
                      :duration="3000"
                      class="item-value linearTextColor-65BFF0 countNumber"
                    />
                    <span v-if="Number(item.amount) >= 10000" class="item-unit linearTextColor-65BFF0">万</span>
                  </div>
                  <div class="item-label">{{ item.title }}</div>
                </div>
              </DynamicCircularRing>
            </div>
            <ScrollingNoticeBar v-if="communityData.communityOrderMessages && communityData.communityOrderMessages.length" :messages="communityData.communityOrderMessages" />
          </div>
        </div>
        <div class="partItem lowerPartItem-2">
          <div class="item-title">
            <span>车位统计</span>
            <img src="./assets/img/title-bottom-line.png" alt="" class="title-bottom-line" />
          </div>
          <div class="chart flex-between">
            <CircularPieChart :data="parkSpaceStatistics" :ringWidth="3" :gapContent="13" :ringSize="140">
              <div class="circularRing circularRing-bg-2">
                <div class="top mb-4">
                  <count-to :start-val="0" :end-val="evaluatorNum(parkSpaceTotal, 0)" :duration="3000" class="item-value linearTextColor-65BFF0 countNumber" />
                  <span v-if="Number(parkSpaceTotal) >= 10000" class="item-unit linearTextColor-65BFF0">万</span>
                </div>
                <div class="item-label">车位总数(个)</div>
              </div>
            </CircularPieChart>
            <div class="detail">
              <div v-for="(item, index) in parkSpaceStatistics" :key="index" class="item" :class="{ 'mb-38': index !== parkSpaceStatistics.length - 1 }">
                <div class="left">
                  <img :src="item.icon" alt="" class="icon" />
                  <span class="item-label linearTextColor-65BFF0">{{ item.label }}</span>
                </div>
                <div class="flex-center">
                  <div class="line"></div>
                  <span class="amount linearTextColor-65BFF0">{{ item.rate }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="partItem lowerPartItem-3">
          <div class="item-title">
            <span>事件感知</span>
            <img src="./assets/img/title-bottom-line.png" alt="" class="title-bottom-line" />
          </div>
          <div class="content">
            <div class="charts flex-between">
              <div v-for="(item, index) in monitorData" :key="index" class="list">
                <DynamicCircularRing
                  :point="false"
                  innerRingBackgroundColor="#042465"
                  :targetDeg="(360 / Number(totalMonitor).toFixed(0)) * Number(item.deviceInfo.value).toFixed(0)"
                  :outerRingDiameter="114"
                  :innerRingDiameter="102"
                  animation
                  :roundColor="item.deviceInfo.roundColor"
                >
                  <div class="context">
                    <div class="circularRing">
                      <div class="top mb-4">
                        <count-to :start-val="0" :end-val="evaluatorNum(item.deviceInfo.value, 0)" :duration="3000" class="item-value linearTextColor-65BFF0 countNumber" />
                        <span v-if="Number(item.deviceInfo.value) >= 10000" class="item-unit linearTextColor-65BFF0">万</span>
                      </div>
                      <div class="item-label">{{ item.deviceInfo.label }}</div>
                    </div>
                    <div
                      v-for="e in 20"
                      :key="e"
                      class="strip__wrapper"
                      :style="{
                        rotate: `${(e * 360) / 20}deg`,
                      }"
                    >
                      <div class="strip" />
                    </div>
                  </div>
                </DynamicCircularRing>
                <div class="bottom mt-32">
                  <div class="top mb-4">
                    <span class="item-value linearTextColor-65BFF0">{{ evaluatorNum(item.optInfo.value, 0) }}</span>
                    <span v-if="Number(item.optInfo.value) >= 10000" class="item-unit linearTextColor-65BFF0">万</span>
                  </div>
                  <div class="item-label">{{ item.optInfo.label }}</div>
                </div>
              </div>
            </div>
            <ScrollingNoticeBar v-if="communityData.communityEventMessages && communityData.communityEventMessages.length" :messages="communityData.communityEventMessages" />
          </div>
        </div>
      </div>
    </div>
  </ScreenHeader>
</template>

<script>
import CountTo from 'vue-count-to'
import ScreenHeader from './components/ScreenHeader'
import DynamicCircularRing from './components/DynamicCircularRing'
import HorizontalBarChart from './components/HorizontalBarChart'
import CircularPieChart from './components/CircularPieChart'
import ScrollingNoticeBar from './components/ScrollingNoticeBar'
import { communityStat } from '@/api/dataScreen'
import { evaluatorNum, evaluatorUnit, countToDecimal } from './assets/js/dataUtil'
export default {
  components: { ScreenHeader, DynamicCircularRing, HorizontalBarChart, CircularPieChart, CountTo, ScrollingNoticeBar },
  data() {
    return {
      currentCommunityId: '',
      timer: null,
      communityData: {},
      evaluatorNum,
      evaluatorUnit,
      countToDecimal,
      // 项目概况
      projectOverview: [
        {
          value: 0,
          label: '管理总面积(m²)',
        },
        {
          value: 0,
          label: '楼栋总数(栋)',
        },
        {
          value: 0,
          label: '单元总数(个)',
        },
        {
          value: 0,
          label: '车场总数(个)',
        },
        {
          value: 0,
          label: '车辆总数(辆)',
        },
        {
          value: 0,
          label: '设备总数(个)',
        },
      ],
      // 工单统计
      workOrderTotal: 0,
      workOrderStatistics: [
        {
          label: '完成数量 ',
          value: 0,
          unit: '单',
          icon: require('./assets/img/rate-1.png'),
        },
        {
          label: '完成率',
          value: 0,
          unit: '%',
          icon: require('./assets/img/rate-2.png'),
        },
        {
          label: '派单耗时',
          value: 0,
          unit: '小时',
          icon: require('./assets/img/rate-3.png'),
        },
        {
          label: '完成耗时',
          value: 0,
          unit: '小时',
          icon: require('./assets/img/rate-4.png'),
        },
      ],
      // 房屋统计
      houseTotal: 0,
      houseStatistics: [
        {
          label: '入住率',
          value: 0,
          rate: 0,
          color: '#5B88D1',
          icon: require('./assets/img/rate-1.png'),
        },
        {
          label: '出租率',
          value: 0,
          rate: 0,
          color: '#5B88D1',
          icon: require('./assets/img/rate-2.png'),
        },
        {
          label: '空置率',
          value: 0,
          rate: 0,
          color: '#5B88D1',
          icon: require('./assets/img/rate-3.png'),
        },
      ],
      // 人员配置
      personnelList: [
        {
          value: 0,
          title: '员工总数(人)',
          roundColor: '#0FA2FD',
        },
        {
          value: 0,
          title: '今日出勤(人)',
          roundColor: '#1BD2F7',
        },
      ],
      personnelData: [
        {
          personnelName: '项目经理',
          value: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#0FA2FD',
          key: 'projectManager',
        },
        {
          personnelName: '客服人员',
          value: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#1BD2F7',
          key: 'call',
        },
        {
          personnelName: '维修人员',
          value: 0,
          apertureColor: 'rgba(53, 238, 192, 0.49)',
          color: '#35EEC0',
          key: 'change',
        },
        {
          personnelName: '保洁人员',
          value: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#0FA2FD',
          key: 'clean',
        },
        {
          personnelName: '保安人员',
          value: 0,
          apertureColor: 'rgba(53, 238, 192, 0.49)',
          color: '#35EEC0',
          key: 'keep',
        },
        {
          personnelName: '绿化人员',
          value: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#1BD2F7',
          key: 'green',
        },
        {
          personnelName: '其他人员',
          value: 0,
          apertureColor: 'rgba(53, 238, 192, 0.49)',
          color: '#35EEC0',
          key: 'other',
        },
      ],
      // 住户统计
      householdStatistics: [
        {
          label: '业主',
          value: 0,
          rate: 0,
          color: '#0C78F2',
          icon: require('./assets/img/rate-5.png'),
        },
        {
          label: '家属',
          value: 0,
          rate: 0,
          color: '#40E2E8',
          icon: require('./assets/img/rate-6.png'),
        },
        {
          label: '租户',
          value: 0,
          rate: 0,
          color: '#0DB0ED',
          icon: require('./assets/img/rate-7.png'),
        },
      ],
      outData: new Array(4).fill({ value: 100, color: '#0AA7FF' }),
      housesHoldTotal: 0,
      otherHouseholdStatistics: [
        {
          label: '老年人',
          value: 0,
          rate: 0,
          color: '#A5E9E7',
          icon: require('./assets/img/oldPeople.png'),
        },
        {
          label: '婴幼儿',
          value: 0,
          rate: 0,
          color: '#A5E9E7',
          icon: require('./assets/img/infant.png'),
        },
        {
          label: '其他',
          value: 0,
          rate: 0,
          color: '#A5E9E7',
          icon: require('./assets/img/other.png'),
        },
      ],
      // 服务统计
      serviceTotal: 0,
      serviceData: [
        {
          label: '巡更次数',
          total: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#0FA2FD',
        },
        {
          label: '巡检次数',
          total: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#1BD2F7',
        },
        {
          label: '维保次数',
          total: 0,
          apertureColor: 'rgba(53, 238, 192, 0.49)',
          color: '#35EEC0',
        },
        {
          label: '保洁次数',
          total: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#0FA2FD',
        },
        {
          label: '保绿次数',
          total: 0,
          apertureColor: 'rgba(53, 238, 192, 0.49)',
          color: '#35EEC0',
        },
      ],
      // 收费情况
      feeSituation: [
        {
          value: 0,
          label: '本年实收',
        },
        {
          value: 0,
          label: '本年优惠',
        },
        {
          value: 0,
          label: '本年退款',
        },
        {
          value: 0,
          label: '本月实收',
        },
      ],
      totalFeeAmount: 0,
      payList: [
        {
          amount: 0,
          title: '线上缴费(元)',
          roundColor: '#0FA2FD',
        },
        {
          amount: 0,
          title: '线下缴费(元)',
          roundColor: '#1BD2F7',
        },
      ],
      // 车位统计
      parkSpaceTotal: 0,
      parkSpaceStatistics: [
        {
          label: '出售率',
          value: 0,
          rate: 0,
          color: '#53A3CE',
          icon: require('./assets/img/rate-8.png'),
        },
        {
          label: '出租率',
          value: 0,
          rate: 0,
          color: '#53A3CE',
          icon: require('./assets/img/rate-2.png'),
        },
        {
          label: '空闲率',
          value: 0,
          rate: 0,
          color: '#53A3CE',
          icon: require('./assets/img/rate-9.png'),
        },
      ],
      monitorData: [
        {
          deviceInfo: {
            label: '报警设备(个)',
            value: 0,
            roundColor: '#00AEFF',
          },
          optInfo: {
            label: '今日报警(次)',
            value: 0,
          },
        },
        {
          deviceInfo: {
            label: '门禁(个)',
            value: 0,
            roundColor: '#0DD0F7',
          },
          optInfo: {
            label: '今日开门(次)',
            value: 0,
          },
        },
        {
          deviceInfo: {
            label: '梯控(个)',
            value: 0,
            roundColor: '#21E3E3',
          },
          optInfo: {
            label: '今日乘梯(次)',
            value: 0,
          },
        },
        {
          deviceInfo: {
            label: '道闸(个)',
            value: 0,
            roundColor: '#007BFF',
          },
          optInfo: {
            label: '今日进出(次)',
            value: 0,
          },
        },
      ],
      totalMonitor: 0,
    }
  },

  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    selectCommunity(id) {
      this.currentCommunityId = id
      this.getList()
    },
    // 获取数据
    async getList() {
      const { data } = await communityStat({
        communityId: this.currentCommunityId,
      })
      if (JSON.stringify(data) === JSON.stringify(this.communityData)) return
      this.communityData = data || {}
      if (!data) return
      this.dataInit(data)
      if (this.timer) return
      this.timer = setInterval(() => {
        this.getList()
      }, 3000)
    },

    dataInit(data) {
      // 项目概况
      if (data.communityProjectStat) {
        this.projectOverview[0].value = data.communityProjectStat.manageArea || 0
        this.projectOverview[1].value = data.communityProjectStat.buildingCount || 0
        this.projectOverview[2].value = data.communityProjectStat.unitCount || 0
        this.projectOverview[3].value = data.communityProjectStat.parkingCount || 0
        this.projectOverview[4].value = data.communityProjectStat.parkingCarCount || 0
        this.projectOverview[5].value = data.communityProjectStat.deviceCount || 0
      }

      // 工单统计
      if (data.worksheetStat) {
        this.workOrderTotal = data.worksheetStat.receiveCount || 0
        this.workOrderStatistics[0].value = data.worksheetStat.completeCount || 0
        this.workOrderStatistics[1].value = data.worksheetStat.completeRate || 0
        this.workOrderStatistics[2].value = data.worksheetStat.assignTime || 0
        this.workOrderStatistics[3].value = data.worksheetStat.dealTime || 0
      }

      //房屋统计
      if (data.buildingRoomStat) {
        this.houseTotal = data.buildingRoomStat.buildingRoomCount || 0
        this.houseStatistics[0].rate = data.buildingRoomStat.isInRate || 0
        this.houseStatistics[1].rate = data.buildingRoomStat.isHireRate || 0
        this.houseStatistics[2].rate = data.buildingRoomStat.isEmptyRate || 0
        this.houseStatistics[0].value = data.buildingRoomStat.isIn || 0
        this.houseStatistics[1].value = data.buildingRoomStat.isHire || 0
        this.houseStatistics[2].value = data.buildingRoomStat.isEmpty || 0
      }

      // 人员配置
      if (data.saasUserStat) {
        this.personnelList[0].value = parseInt(data.saasUserStat.malePercent || 0) + parseInt(data.saasUserStat.femalePercent || 0)
        this.personnelList[1].value = data.saasUserStat.attendanceCountThisDay || 0
      }
      // 职位
      if (data.staffPositionStat) {
        this.personnelData.forEach(item => {
          item.value = data.staffPositionStat[item.key] || 0
        })
      }

      // 住户统计
      if (data.householdAssert) {
        this.householdStatistics[0].rate = data.householdAssert.ownerRatio || 0
        this.householdStatistics[1].rate = data.householdAssert.familyRatio || 0
        this.householdStatistics[2].rate = data.householdAssert.tenantRatio || 0
        this.householdStatistics[0].value = data.householdAssert.ownerCount || 0
        this.householdStatistics[1].value = data.householdAssert.familyCount || 0
        this.householdStatistics[2].value = data.householdAssert.tenantCount || 0
      }
      if (data.householdStat) {
        this.otherHouseholdStatistics[0].rate = data.householdStat.oldPeopleRatio || 0
        this.otherHouseholdStatistics[1].rate = data.householdStat.babyPeopleRatio || 0
        this.otherHouseholdStatistics[2].rate = data.householdStat.unKnowPeopleRatio || 0
        this.otherHouseholdStatistics[0].value = data.householdStat.oldPeopleCount || 0
        this.otherHouseholdStatistics[1].value = data.householdStat.babyPeopleCount || 0
        this.otherHouseholdStatistics[2].value = data.householdStat.unKnowPeopleCount || 0
      }
      this.housesHoldTotal = data.householdAssert.peopleCount + data.householdStat.peopleCount

      // 服务统计
      this.serviceData[0].total = data.patrolCount || 0
      this.serviceData[1].total = data.inspectCount || 0
      this.serviceData[2].total = data.maintainCount || 0
      this.serviceData[3].total = data.cleanCount || 0
      this.serviceData[4].total = data.greenCount || 0
      this.serviceTotal = 0
      this.serviceData.forEach(item => (this.serviceTotal += parseInt(item.total)))

      // 收费情况
      if (data.financeOrderStatDTO) {
        this.feeSituation[0].value = data.financeOrderStatDTO.thisYearReceived || 0
        this.feeSituation[1].value = data.financeOrderStatDTO.thisYearPreAmount || 0
        this.feeSituation[2].value = data.financeOrderStatDTO.thisYearRefund || 0
        this.feeSituation[3].value = data.financeOrderStatDTO.thisMonthReceived || 0
        this.payList[0].amount = data.financeOrderStatDTO.onlinePayment || 0
        this.payList[1].amount = data.financeOrderStatDTO.offlinePayment || 0
        this.totalFeeAmount = 0
        this.payList.forEach(item => (this.totalFeeAmount += item.amount))
      }

      // 车位统计
      if (data.parkingSpaceStat) {
        this.parkSpaceTotal = data.parkingSpaceStat.parkingSpaceCount || 0
        this.parkSpaceStatistics[0].rate = data.parkingSpaceStat.sellRate || 0
        this.parkSpaceStatistics[1].rate = data.parkingSpaceStat.rentRate || 0
        this.parkSpaceStatistics[2].rate = data.parkingSpaceStat.emptyRate || 0
        this.parkSpaceStatistics[0].value = parseInt(data.parkingSpaceStat.sellRate) * this.parkSpaceTotal
        this.parkSpaceStatistics[1].value = parseInt(data.parkingSpaceStat.rentRate) * this.parkSpaceTotal
        this.parkSpaceStatistics[2].value = parseInt(data.parkingSpaceStat.emptyRate) * this.parkSpaceTotal
      }

      // 监控
      this.monitorData[0].deviceInfo.value = data.monitorEventCount || 0
      this.monitorData[0].optInfo.value = data.monitorEventUseCount || 0
      this.monitorData[1].deviceInfo.value = data.accessCount || 0
      this.monitorData[1].optInfo.value = data.accessUseCount || 0
      this.monitorData[2].deviceInfo.value = data.ladderCount || 0
      this.monitorData[2].optInfo.value = data.ladderUseCount || 0
      this.monitorData[3].deviceInfo.value = data.parkingGateCount || 0
      this.monitorData[3].optInfo.value = data.parkingGateUseCount || 0
      this.totalMonitor = 0
      this.monitorData.forEach(item => (this.totalMonitor += item.deviceInfo.value))
    },
  },
}
</script>

<style lang="scss" scoped>
@import './assets/css/charts.scss';
.chart-container {
  padding: vh(8.75) vw(24) vh(32);
  box-sizing: border-box;
  .countNumber {
    display: inline-block;
  }
  .partItem {
    width: vw(621);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url('./assets/img/projectLargeScreen-item-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .item-title {
    display: flex;
    flex-direction: column;
    margin-bottom: vh(26);
    font-weight: 500;
    font-size: rem(15);
    background: linear-gradient(180deg, #afccf7 2%, #74a1e3 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    .title-bottom-line {
      width: vw(72);
      height: vh(12);
    }
  }
  .linearTextColor-65BFF0 {
    background: linear-gradient(180deg, #ffffff 0%, #65bff0 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  .item-value {
    font-family: 'HarmonyOSSansSCBold';
    font-size: rem(20);
    font-weight: 700;
  }
  .item-unit {
    font-size: rem(14);
    font-weight: 500;
  }
  .item-label {
    color: #74a1e3;
    font-size: rem(13);
  }
  .circularRing {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .circularRing-bg {
    background: rgba(19, 141, 255, 0.01);
    box-shadow: inset 0px 0px vh(3) 0px #5d8dda, inset 0px 0px vh(30) 0px #185cb1;
  }
  .circularRing-bg-2 {
    background: rgba(19, 141, 255, 0.01);

    box-shadow: inset 0px 0px vh(3) 0px rgba(50, 198, 221, 0.48), inset 0px 0px vh(30) 0px rgba(29, 213, 250, 0.51);
  }
  .detail {
    .item {
      .left {
        display: flex;
        align-items: center;
        .icon {
          width: vw(18);
          height: vw(18);
          margin-right: vw(11);
        }
      }
      .amount {
        font-family: 'HarmonyOSSansSCBold';
        font-size: rem(20);
        font-weight: 700;
      }
      .right {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
  }
  .upperPart {
    .chart {
      width: 100%;
    }
    .line {
      width: vw(161);
      height: 0;
      margin: 0 vw(16) 0;
      border-top: 1px dashed rgba(255, 255, 255, 0.19);
    }
    .upperPartItem-1 {
      height: vh(290);
      padding: vh(14) vw(32) vh(24);
      .content {
        display: grid;
        grid-row-gap: vh(52);
        grid-column-gap: vw(124);
        grid-template-columns: auto auto auto;
        .detailItem {
          text-align: center;
        }
      }
    }
    .upperPartItem-2 {
      height: vh(290);
      padding: vh(14) vw(34) vh(24);
    }
    .upperPartItem-3 {
      display: flex;
      flex-direction: column;
      height: vh(290);
      padding: vh(14) vw(32) vh(9);
      .content {
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
      }
      .detail {
        .leftBox {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: vw(81);
          .icon {
            width: vw(18);
            height: vw(18);
            margin-right: vw(11);
          }
        }
      }
      .totalDetail {
        width: vw(112);
        height: vw(112);
      }
    }
  }
  .centerPart {
    .centerPartItem-1 {
      height: vh(334);
      padding: vh(14) vw(32) vh(25);
      .content {
        width: 100%;
        flex: 1;
        .charts {
          height: 100%;
          flex-direction: column;
        }
        .rightDetail {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .list {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .left {
              .label {
                font-size: rem(13);
                color: #74a1e3;
              }
            }
            .right {
              font-size: rem(14);
              font-weight: 500;
              margin-left: vw(14);
              .value {
                font-size: rem(20);
                font-weight: 700;
                font-family: 'HarmonyOSSansSCBold';
              }
            }
          }
        }
      }
    }
    .centerPartItem-2 {
      height: vh(334);
      padding: vh(14) vw(32) vh(61);
      .center {
        width: 100%;
        margin-bottom: vh(44);
        .context {
          border-radius: 9999px;
          text-align: center;
          color: #fff;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          .strip__wrapper {
            position: absolute;
            width: 100%;
            height: 100%;
            .strip {
              width: vw(2);
              height: vh(8);
              left: 50%;
              transform: translateX(-50%);
              background: #b7defd17;
              position: absolute;
            }
          }
        }
        .detail {
          .item {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .line {
              width: vw(174);
              height: 0;
              margin: 0 vw(16) 0;
              border-top: 1px dashed rgba(255, 255, 255, 0.19);
            }
          }
        }
      }
      .bottom {
        width: 100%;
        .line {
          width: vw(30);
          height: 0;
          margin: 0 vw(12) 0;
          border-top: 1px dashed rgba(255, 255, 255, 0.19);
        }
      }
    }
    .centerPartItem-3 {
      display: flex;
      flex-direction: column;
      height: vh(334);
      padding: vh(14) vw(32);
      .content {
        flex: 1;
        width: 100%;
      }
      .chart-service {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .list {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .value {
            margin-left: vw(14);
          }
        }
      }
    }
  }
  .lowerPart {
    .lowerPartItem-1 {
      height: vh(336);
      padding: vh(14) vw(41) vh(12);
      display: flex;
      flex-direction: column;
      .content {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
      }
      .situation {
        width: 100%;
        .top {
          text-align: center;
        }
      }
      .charts {
        width: 100%;
        padding: 0 vw(68);
        box-sizing: border-box;
      }
    }
    .lowerPartItem-2 {
      height: vh(336);
      padding: vh(14) vw(32);
      .item-title {
        margin-bottom: vh(50);
      }
      .chart {
        width: 100%;
        .detail {
          .item {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .line {
              width: vw(161);
              height: 0;
              margin: 0 vw(16) 0;
              border-top: 1px dashed rgba(255, 255, 255, 0.19);
            }
          }
        }
      }
    }
    .lowerPartItem-3 {
      height: vh(336);
      padding: vh(14) vw(32) vh(12);
      display: flex;
      flex-direction: column;
      .item-title {
        margin-bottom: vh(22);
      }
      .content {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .charts {
          width: 100%;
          .list {
            text-align: center;
          }
          .context {
            border-radius: 9999px;
            text-align: center;
            color: #fff;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .strip__wrapper {
              position: absolute;
              width: 100%;
              height: 100%;
              .strip {
                width: vw(2);
                height: vh(8);
                left: 50%;
                transform: translateX(-50%);
                background: #b7defd17;
                position: absolute;
                top: vh(4);
              }
            }
          }
        }
      }
    }
  }
}
</style>
